(function (app) {
    var annualPlanning = {
        Year: 2017
    };

    app.provider("marketingKitApi", [function () {
        this.$get = ["$q", "portalApiGateway", function ($q, portalApiGateway) {
            var service = {};
           
            service.getOnboardingKit = function () {
                return portalApiGateway.get("/MarketingKits/GetOnboardingKit");
            };

            service.saveOnboardingKit = function (form) {
                return portalApiGateway.post("/MarketingKits/OnboardingKit", form);
            };           

            service.getAnnualPlanningKitYears = function () {
                return portalApiGateway.get("/MarketingKits/GetAnnualPlanningKit/Years");
            };

            service.getAnnualPlanningKitByYear = function (year) {
                return portalApiGateway.get("/MarketingKits/GetAnnualPlanningKit/" + year);
            };
         
            service.saveAnnualPlanningKit = function (form) {
                return portalApiGateway.post("/MarketingKits/AnnualPlanningKit", form);
            };          

            return service;
        }];
    }]);
})(window.app); // jshint ignore:line